export interface ZustandBannersStore extends ZustandBannersStoreEntity {
  setBanners: (banners: Banners) => void;
}

interface ZustandBannersStoreEntity {
  banners: Banners | null;
}

export type Banners = {
  mobile: Banner[];
  desktop: Banner[];
};

export type Banner = {
  // Notice:Enum
  actionType: EBannerAction;
  actionValue: string;
  countryDependencies: number[];
  depositDependency: number;
  exceptFor: number[];
  id: number;
  isAuthDependency: boolean;
  name: string;
  path: string;
  order: number;
  translations: BannerTranslates;
  redirect: {
    [lang: string]: string;
  };
  updateAt: string;
};

export type BannerTranslates = {
  [lang: string]: {
    title: string;
    subTitle?: string;
    buttonText: string;
  };
};

export enum EBannerAction {
  Unknown,
  PopUp,
  Navigate,
  ExternalNavigate,
}
